import { useEffect } from 'react';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { H4 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function InsightsEmptyState({
  panelName
}) {
  useEffect(() => {
    trackInsightsInteraction({
      action: 'render-empty-insights-panel'
    });
  });
  const description = panelName === 'listing' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "messaging-insights.insights.emptyState.listingPanelDescription"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "messaging-insights.insights.emptyState.detailPanelDescription"
  });
  return /*#__PURE__*/_jsx("div", {
    className: "text-center",
    children: /*#__PURE__*/_jsx(UIEmptyState, {
      primaryContent: /*#__PURE__*/_jsx(UIIllustration, {
        name: "empty-state-charts",
        width: 150
      }),
      secondaryContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "messaging-insights.insights.emptyState.title"
          })
        }), description]
      })
    })
  });
}
export default InsightsEmptyState;